import { useEffect, useRef } from 'react';

export function usePlaybackCallbacks({
  isPlaying,
  onPlay,
  onPause
}: {
  isPlaying: boolean;
  onPlay?: () => void;
  onPause?: () => void;
}): void {
  const lastIsPlayingRef = useRef<boolean | null>(null);

  useEffect(() => {
    if (lastIsPlayingRef.current === null) {
      lastIsPlayingRef.current = isPlaying;
      return;
    }
    if (lastIsPlayingRef.current !== isPlaying) {
      if (isPlaying) {
        onPlay?.();
      } else {
        onPause?.();
      }
      lastIsPlayingRef.current = isPlaying;
    }
  }, [isPlaying, onPause, onPlay]);
}
